import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hideDeleteCompletedEvent'
})
export class HideDeleteCompletedEventPipe implements PipeTransform {
  transform(rowData: any): boolean {
    // Return false to hide the delete button for completed events
    return rowData?.isEventCompleted !== 1;
  }
}
